import React from 'react'
import _ from 'lodash'
import { connect } from 'react-redux'
import { getSelectedStore } from 'x/redux/selectors'

// import api from 'x/utils/api'
import * as util from 'x/utils/util'
import * as acl from 'x/utils/acl'
import CONS from 'x/config/constants'
import { COLORS, S } from 'x/config/styles'
import p from 'x/config/platform-specific'

import VStack from 'xui/components/VStack'
import HStack from 'xui/components/HStack'
import XText from 'xui/components/XText'
import XInput from 'xui/components/XInput'
import XIconButton from 'xui/components/XIconButton'
import {
  ISearchProductVariantListViewProps,
  ISearchProductVariantListViewState,
  ISearchProductItem,
  IProductListFilterTemplate,
  ICategory,
  IBarcodeScannerOutput,
  IProductVariantType,
} from 'x/types'
import { FlatList, ListRenderItemInfo, RefreshControl, TextInput, TouchableOpacity } from 'react-native'
import * as api from 'x/utils/api'
import Box from 'xui/components/Box'
import XSpinner from 'xui/components/XSpinner'
import ErrorListItem from 'xui/components/ErrorListItem'
import XIcon from 'xui/components/XIcon'

import * as NavActions from 'x/utils/navigation'
import ProductVariantListFilterTemplateSelector from 'xui/components/product/ProductVariantListFilterTemplateSelector'
import { diff } from 'deep-object-diff'
import ProductCategorySelector from 'xui/components/product/ProductCategorySelector'
import SearchProductVariantListItem from 'xui/components/product/SearchProductVariantListItem'
import BarcodeScannerModalButton from 'xui/components/BarcodeScannerModalButton'
import XOverlay from 'xui/components/XOverlay'
import XCustomHeader from 'xui/components/XCustomHeader'
import XSwitch from 'xui/components/XSwitch'
import XButton from 'xui/components/XButton'
import BaseUIProductVariantListView from './BaseUIProductVariantListView'

// const { NAME, COST, PRICE, PRICE_RETAIL, QTY, AVAILABLE_QTY, WEIGHT, H, SKU, UPC, CATEGORY } = CONS.PRODUCT_ATTR

class SearchProductVariantListView extends BaseUIProductVariantListView<
  ISearchProductVariantListViewProps,
  ISearchProductVariantListViewState
> {
  static displayName = 'SearchProductVariantListView'
}

export default connect(
  (state) => ({
    selectedStore: getSelectedStore(state),
  }),
  (dispatch) => ({
    dispatch,
  })
)(SearchProductVariantListView)
